import { render } from "./verresListe.vue?vue&type=template&id=2b69f97c&scoped=true"
import script from "./verresListe.vue?vue&type=script&lang=js"
export * from "./verresListe.vue?vue&type=script&lang=js"

import "./verresListe.vue?vue&type=style&index=0&id=2b69f97c&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b69f97c"]])

export default __exports__